import React from "react";
import { motion } from "framer-motion";

import { EASE, DURATION } from "../lib/motion";

export default function Reveal({ children, className = "", delay = 0 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: DURATION, ease: EASE, delay: delay / 1000 }}
    >
      {children}
    </motion.div>
  );
}
